import React from 'react';
import NotificationContent from '../_partials/NotificationContent';
import { useCustomNotifications } from '../CustomNotificationContext';
export var CustomNotification = function (_a) {
    var notificationTypes = _a.notificationTypes, customNotificationRender = _a.customNotificationRender;
    var _b = useCustomNotifications(notificationTypes), notifications = _b.notifications, removeNotification = _b.removeNotification;
    var currentNotification = notifications[0];
    if (!currentNotification) {
        return null;
    }
    return (React.createElement(NotificationContent, { notification: currentNotification, removeNotification: removeNotification }, customNotificationRender));
};
CustomNotification.displayName = 'CustomNotification';
export default CustomNotification;
//# sourceMappingURL=CustomNotification.js.map